import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { styled } from "@mui/material/styles";
import { Card, Stack, Container, Typography } from "@mui/material";
import { login } from "../DAL/Login/Login";
import Page from "../components/Page";
import { MHidden } from "../components/@material-extend";
import { LoginForm } from "../components/authentication/login";
import { ProjectInfoApi } from "src/DAL/SiteSetting/siteSetting";
import { s3baseUrl } from "src/config/config";
import { useContentSetting } from "src/Hooks/ContentSettingState";

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

export default function Login() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [projectInfo, setProjectInfo] = useState({});
  const { handleSetUserInfo, START_SOCKET_FORCEFULLY, handleGoogleId } =
    useContentSetting();

  const getProjectInfo = async () => {
    const result = await ProjectInfoApi();
    if (result.code === 200) {
      setProjectInfo(result.default_setting);
    }
  };

  const handleSubmitLogin = async (data) => {
    setLoading(true);
    const result = await login(data);
    if (result.code === 200) {
      localStorage.setItem("token", result.token);
      localStorage.setItem("email", result.adminUser?.email);
      localStorage.setItem("is_send_code", result.adminUser?.is_send_code);
      localStorage.setItem(
        "is_verified_code",
        result.adminUser?.is_verified_code,
      );
      localStorage.setItem(
        "verification_code",
        result.adminUser?.verification_code,
      );
      localStorage.setItem("name", result.adminUser?.name);
      localStorage.setItem("_id", result.adminUser?._id);
      localStorage.setItem("image", result.adminUser?.image?.thumbnail_1);
      START_SOCKET_FORCEFULLY(result.adminUser?._id);
      handleSetUserInfo(result.adminUser);

      console.log(result, "localstorageData");
      localStorage.setItem(`user_data`, JSON.stringify(result.adminUser));
      if (result.site_setting) {
        handleGoogleId(result.site_setting);
      }
      enqueueSnackbar(result.message, { variant: "success" });
      navigate("/programmes", { replace: true });
      setLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setLoading(false);
    }
  };

  useEffect(() => {
    getProjectInfo();
  }, []);

  return (
    <RootStyle>
      <MHidden width="mdDown">
        <SectionStyle>
          <Typography
            variant="h3"
            sx={{ px: 5, mt: 10, mb: 5, color: "black" }}
          >
            Hi, Welcome Back
          </Typography>
          <div className="d-flex justify-content-center ">
            <img
              src={s3baseUrl + projectInfo?.admin_background_image}
              alt="login"
              style={{ width: 275, height: 250 }}
            />
          </div>
        </SectionStyle>
      </MHidden>
      <Container maxWidth="sm" className="">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom sx={{ color: "black" }}>
              <div
                dangerouslySetInnerHTML={{
                  __html: projectInfo?.admin_login_page_text,
                }}
              ></div>
            </Typography>
          </Stack>

          <LoginForm isLoading={loading} onhandleLogin={handleSubmitLogin} />

          <MHidden width="smUp">
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Don’t have an account?&nbsp;
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
